// NOSONAR — `createStore` is deprecated in newer redux typings, but migrating
// to @reduxjs/toolkit is out of scope for this change (see design.md). The
// runtime behavior is unchanged from the previous inline store in src/index.jsx.
import { applyMiddleware, compose, createStore } from 'redux'; // NOSONAR
import thunk from 'redux-thunk';

import reducers from './reducers/root';

const middleware = applyMiddleware(thunk);
const reduxDevtoolsExtension = globalThis.window?.__REDUX_DEVTOOLS_EXTENSION__;
const enhancer = reduxDevtoolsExtension ? compose(middleware, reduxDevtoolsExtension()) : middleware;

export const store = createStore(reducers, enhancer); // NOSONAR
